import { BuildingId } from '../../specification/buildings/BuildingSpecification';
import { Project } from '../../project/Project';
import { Maybe } from '../../../utils/Maybe';
import { CaseId } from '../../specification/cases/CaseSpecification';
import { hasCaseId } from '../../specification/cases/queries/has/hasCaseId';

export const getBuildingIdFromCaseId = (project: Project, caseId: CaseId): Maybe<BuildingId> =>
  project.buildings.find((building) => building.cases.some(hasCaseId(caseId)))?.id;
